export default __webpack_public_path__ + "static/media/hht2_ep19_timeline_q02_a.cfe7be58.png";